var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.819,
    height: 14.803,
    viewBox: "0 0 14.819 14.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.86,16.341v-.925a.474.474,0,0,0-.463-.463H4.313a.474.474,0,0,1-.463-.463V4.313a.474.474,0,0,1,.463-.463H7.4a.474.474,0,0,0,.463-.463V2.463A.474.474,0,0,0,7.4,2H3.234A1.237,1.237,0,0,0,2,3.234V15.57A1.237,1.237,0,0,0,3.234,16.8H7.4A.474.474,0,0,0,7.86,16.341Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.979,15.9a.447.447,0,0,0,0-.648l-4.163-4.163a.447.447,0,0,0-.648,0l-.648.648a.447.447,0,0,0,0,.648l1.727,1.727a.308.308,0,0,1-.216.524H14.463a.448.448,0,0,0-.463.432v.925a.5.5,0,0,0,.463.493H21a.308.308,0,0,1,.216.524l-1.727,1.727a.447.447,0,0,0,0,.648l.648.648a.447.447,0,0,0,.648,0Z",
    transform: "translate(-8.299 -6.19)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic-logout.81151058.svg";
export { ForwardRef as ReactComponent };